import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Modal, Button } from "react-bootstrap";
import { DeleteDepartmentAPI } from "../../../../services/api/department-api";
import { DeleteRolesNew } from "../../../../services/api/role-api";
import { DeleteUserNew } from "../../../../services/api/user-api";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectUserID } from "../../../../redux/user/user-selector";
import {
  fetchDepartments,
  setSelectedDepartments,
} from "../../../../redux/departments/department-actions";
import {
  fetchRoles,
  setSelectedRoles,
} from "../../../../redux/admin/roles/roles-actions";
import {
  fetchUsers,
  setSelectedUser,
} from "../../../../redux/users/users-actions";
import { selectSearchDepartmentsQuery } from "../../../../redux/departments/department-selector";
import { selectSearchRolesQuery } from "../../../../redux/admin/roles/roles-selector";
import { selectSearchQueryUsers } from "../../../../redux/users/users-selector";
import "./admin-actions-popup.styles.scss";
import { PulseLoader } from "react-spinners";
import {
  fetchGroups,
  setSelectedGroups,
} from "../../../../redux/groups/group-actions";
import { selectSearchGroupsQuery } from "../../../../redux/groups/group-selector";
import { DeleteGroupAPI } from "../../../../services/api/group-api";
import {
  DeleteProjectTemplateAPI,
  DeleteTemplateTaskAPI,
} from "../../../../services/api/project-template-api";
import {
  fetchTemplates,
  setSelectedTemplate,
} from "../../../../redux/templates/template-actions";
import { selectSearchTemplatesQuery } from "../../../../redux/templates/template-selector";
import { selectSearchTemplateTasksQuery } from "../../../../redux/templates-tasks/template-task-selector";
import {
  fetchTemplateTasks,
  setSelectedTemplateTasks,
} from "../../../../redux/templates-tasks/template-task-actions";

const AdminActionsPopupNew = ({
  showAdminActionsPopup,
  setShowAdminActionsPopup,
  type,
  selectedIDs,
  name,
  userID,
  searchQueryDepartments,
  fetchDepartments,
  setSelectedDepartments,
  searchQueryRoles,
  fetchRoles,
  setSelectedRoles,
  searchQueryGroups,
  fetchGroups,
  setSelectedGroups,
  searchQueryUsers,
  fetchUsers,
  setSelectedUsers,
  searchQueryTemplates,
  fetchTemplates,
  setSelectedTemplates,
  searchQueryTemplateTasks,
  fetchTemplateTasks,
  setSelectedTemplateTasks,
  onArchiveSuccess
}) => {
  const [loading, setLoading] = useState(false); // used to disable buttons while api call is made.
  const [submitted, setSubmitted] = useState(false); // when user submits
  const [submitSuccess, setSubmitSuccess] = useState(false); //  checks if submit was successful
  const [title, setTitle] = useState("");
  const [results, setResults] = useState([]);

  useEffect(() => {
    let title = "";
    if (type.includes("department")) {
      title = "Archive Department";
    } else if (type.includes("group")) {
      title = "Archive Group";
    } else if (type.includes("role")) {
      title = "Archive Role";
    } else if (type.includes("user")) {
      title = "Archive User";
    } else if (type.includes("template")) {
      title = "Archive Template";
    } else if (type.includes("task")) {
      title = "Archive Template Task";
    }

    title = selectedIDs.length > 1 ? `${title}s` : title;
    setTitle(title);
  }, []);

  const handleClose = () => {
    setShowAdminActionsPopup(false);

    submitted &&
      type.includes("department") &&
      fetchDepartments(searchQueryDepartments);
    submitted && type.includes("role") && fetchRoles(searchQueryRoles);
    submitted && type.includes("group") && fetchGroups(searchQueryGroups);
    submitted && type.includes("user") && fetchUsers(searchQueryUsers);
    submitted &&
      type.includes("template") &&
      fetchTemplates(searchQueryTemplates);
    submitted &&
      type.includes("task") &&
      fetchTemplateTasks(searchQueryTemplateTasks);

    submitted && clearSelectedRows();
  };

  const clearSelectedRows = () => {
    switch (type) {
      case "department":
        setSelectedDepartments([]);
        break;
      case "role":
        setSelectedRoles([]);
        break;
      case "group":
        setSelectedGroups([]);
        break;
      case "user":
        setSelectedUsers([]);
        break;
      case "template":
        setSelectedTemplates([]);
        break;
      case "task":
        setSelectedTemplateTasks([]);
        break;
      default:
        break;
    }
  };

  const handleSubmit = async () => {
    try {
      let input = { userID: userID, deleteIDs: selectedIDs };
      let output = {};
      setLoading(true);
      setSubmitted(true);

      if (type.includes("department"))
        output = await DeleteDepartmentAPI(selectedIDs);
      else if (type.includes("user"))
        output = await DeleteUserNew(input.deleteIDs);
      else if (type.includes("role")) output = await DeleteRolesNew(input.deleteIDs);
      else if (type.includes("group"))
        output = await DeleteGroupAPI(selectedIDs);
      else if (type.includes("task"))
        output = await DeleteTemplateTaskAPI(selectedIDs);
      else if (type.includes("template"))
        output = await DeleteProjectTemplateAPI(selectedIDs);

      if (output?.status === 200) {
        setTitle("Archive Confirmation");
        setLoading(false);
        setSubmitSuccess(true);
        if(type.includes("template") || type.includes("group") || type.includes("user")) //as template, user and group are the only ones that have this function
          {
            onArchiveSuccess();
          }
        // if it failed or partially failed
      } else {
        setSubmitSuccess(false);
        setLoading(false);
        setResults(output?.response?.data);
      }
    } catch (error) {
      setSubmitSuccess(false);
      setLoading(false);
      console.log(error);
    }
  };

  return (
    <Modal
      show={showAdminActionsPopup}
      onHide={() => handleClose()}
      dialogClassName="admin-actions-popup"
    >
      <Modal.Header>
        <Modal.Title className="modal-title-1">{title}</Modal.Title>
        <Button
          className="close-document-viewer-btn btn-primary"
          onClick={() => handleClose()}
        ></Button>
      </Modal.Header>
      <div className="select-member-divider-line"></div>
      {!loading ? (
        !submitted ? (
          <Modal.Body>
            <div className="admin-popup-icon archive-popup-icon"></div>
            <div className="admin-popup-message">
              {selectedIDs.length === 1 ? (
                <div>
                  <div className="admin-popup-message">
                    {`Are you sure you want to archive the ${type}:`}
                  </div>
                  <div
                    className="admin-popup-message bolded-name"
                    style={{ fontWeight: "bold" }}
                  >
                    {name} <span style={{ fontWeight: "normal" }}> ?</span>
                  </div>
                </div>
              ) : (
                <React.Fragment>
                  Are you sure you want to archive&nbsp;
                  <span style={{ fontWeight: "bold" }}>
                    {`${selectedIDs.length} ${type}s`}
                  </span>
                  ?
                </React.Fragment>
              )}
            </div>

            <div className="admin-popup-btn-container">
              <Button
                disabled={loading}
                className="btn-wide table-buttons-container"
                onClick={async () => await handleSubmit()}
              >
                Yes
              </Button>
              <Button
                className="btn-wide btn-outlined"
                onClick={() => handleClose()}
              >
                No
              </Button>
            </div>
          </Modal.Body>
        ) : submitSuccess ? (
          <Modal.Body>
            <div className="admin-popup-icon submitted-popup-icon"></div>
            <div className="admin-popup-message">
              Archive successful. Contact support@triyo.io to unarchive
            </div>

            <div className="admin-popup-btn-container">
              <Button
                className="btn-wide table-buttons-container"
                onClick={() => handleClose()}
              >
                OK
              </Button>
            </div>
          </Modal.Body>
        ) : (
          <Modal.Body>
            <div className="admin-popup-icon failed-popup-icon"></div>
            {selectedIDs.length === 1 ? (
              <div>
                <div className="admin-popup-message">
                  {`Failed to archive ${type}:`}
                </div>
                <div
                  className="admin-popup-message bolded-name"
                  style={{ fontWeight: "bold" }}
                >
                  {name}
                </div>
                <div className="admin-popup-message-small">
                  {`as it is linked to active projects or tasks`}
                </div>
              </div>
            ) : selectedIDs?.length === results?.length ? (
              <React.Fragment>
                <div className="admin-popup-message">
                  Failed to archive&nbsp;
                  <span style={{ fontWeight: "bold" }}>
                    {`${selectedIDs.length} ${type}s (`}
                    {results.map((result, index) => {
                      return (
                        <React.Fragment>
                          {index === results?.length - 1 ? (
                            <span>{` ${result} `}</span>
                          ) : (
                            <span>{` ${result},`}</span>
                          )}
                        </React.Fragment>
                      );
                    })}
                    {`)`}
                  </span>
                </div>
                <div className="admin-popup-message-small">
                  {`as they are linked to active projects or tasks`}
                </div>
              </React.Fragment>
            ) : (
              <div className="admin-popup-message">{`Some ${type}s could not be archived as they are linked to active projects or tasks`}</div>
            )}
            <div className="admin-popup-btn-container">
              <Button
                className="btn-wide table-buttons-container"
                onClick={() => handleClose()}
              >
                OK
              </Button>
            </div>
          </Modal.Body>
        )
      ) : (
        <div className="modal-loader">
          <PulseLoader />
        </div>
      )}
    </Modal>
  );
};

const mapState = createStructuredSelector({
  userID: selectUserID,
  searchQueryDepartments: selectSearchDepartmentsQuery,
  searchQueryRoles: selectSearchRolesQuery,
  searchQueryGroups: selectSearchGroupsQuery,
  searchQueryUsers: selectSearchQueryUsers,
  searchQueryTemplates: selectSearchTemplatesQuery,
  searchQueryTemplateTasks: selectSearchTemplateTasksQuery,
});

const mapDispatch = (dispatch) => ({
  fetchDepartments: (searchQuery) => dispatch(fetchDepartments(searchQuery)),
  fetchRoles: (searchQuery) => dispatch(fetchRoles(searchQuery)),
  fetchGroups: (searchQuery) => dispatch(fetchGroups(searchQuery)),
  fetchTemplates: (searchQuery) => dispatch(fetchTemplates(searchQuery)),
  fetchTemplateTasks: (searchQuery) =>
    dispatch(fetchTemplateTasks(searchQuery)),
  setSelectedDepartments: (idList) => dispatch(setSelectedDepartments(idList)),
  setSelectedRoles: (idList) => dispatch(setSelectedRoles(idList)),
  setSelectedGroups: (idList) => dispatch(setSelectedGroups(idList)),
  fetchUsers: (searchQuery) => dispatch(fetchUsers(searchQuery)),
  setSelectedUsers: (idList) => dispatch(setSelectedUser(idList)),
  setSelectedTemplates: (idList) => dispatch(setSelectedTemplate(idList)),
  setSelectedTemplateTasks: (idList) =>
    dispatch(setSelectedTemplateTasks(idList)),
});

AdminActionsPopupNew.propTypes = {
  showAdminActionsPopup: PropTypes.bool.isRequired,
  setShowAdminActionsPopup: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  selectedIDs: PropTypes.array.isRequired,
  searchQueryDepartments: PropTypes.object.isRequired,
  fetchDepartments: PropTypes.func.isRequired,
  setSelectedDepartments: PropTypes.func.isRequired,
  searchQueryRoles: PropTypes.object.isRequired,
  fetchRoles: PropTypes.func.isRequired,
  setSelectedRoles: PropTypes.func.isRequired,
  searchQueryGroups: PropTypes.object.isRequired,
  fetchGroups: PropTypes.func.isRequired,
  setSelectedGroups: PropTypes.func.isRequired,
  userID: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  searchQueryUsers: PropTypes.object.isRequired,
  fetchUsers: PropTypes.func.isRequired,
  setSelectedUsers: PropTypes.func.isRequired,
  searchQueryTemplates: PropTypes.object.isRequired,
  fetchTemplates: PropTypes.func.isRequired,
  setSelectedTemplates: PropTypes.func.isRequired,
  searchQueryTemplateTasks: PropTypes.object.isRequired,
  fetchTemplateTasks: PropTypes.func.isRequired,
  setSelectedTemplateTasks: PropTypes.func.isRequired,
  onArchiveSuccess: PropTypes.func,
};
export default connect(mapState, mapDispatch)(AdminActionsPopupNew);
